import { useState } from "react";
import PageLayout from "@/components/PageLayout";
import { api, IMAGES } from "@/lib/api";
import { Footprints, Bell, MapPin, Calendar } from "lucide-react";

export default function FiveK() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true); setError("");
        try {
            await api.post("/5k-notify", { name, email });
            setDone(true);
        } catch (err) {
            setError(err?.response?.data?.detail || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageLayout>
            <section className="relative overflow-hidden">
                <div className="absolute inset-0">
                    <img src={IMAGES.charityRun} alt="" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-r from-stone-900/85 via-stone-900/70 to-stone-900/50" />
                </div>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 md:py-40 text-white" data-testid="5k-hero">
                    <div className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase bg-brand-cream/10 border border-white/30 rounded-full px-4 py-2 backdrop-blur">
                        <Footprints size={14} /> Annual Charity Run
                    </div>
                    <h1 className="mt-6 font-serif text-5xl sm:text-7xl tracking-tight max-w-3xl leading-[0.95]">
                        Poppa &amp; Gigi&apos;s <span className="text-brand-lime-light">5K Run</span>
                    </h1>
                    <div className="font-accent text-4xl mt-2 text-amber-200">Coming Soon</div>
                    <p className="mt-6 text-lg max-w-xl text-stone-200 leading-relaxed">
                        Lace up your sneakers and walk, jog, or run with us — every step funds support for grandparent-led families. Be the first to know when registration opens.
                    </p>
                </div>
            </section>

            <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-6">
                {[
                    { icon: Calendar, title: "Date", body: "Coming soon — Fall 2026" },
                    { icon: MapPin, title: "Location", body: "Details to be announced" },
                    { icon: Bell, title: "Updates", body: "Sign up below to get notified first" },
                ].map((c, i) => (
                    <div key={i} className="bg-brand-cream rounded-3xl p-7 border border-stone-100 hover-lift" data-testid={`5k-info-card-${i}`}>
                        <c.icon className="text-brand-purple" />
                        <div className="mt-4 text-xs uppercase tracking-[0.25em] text-stone-500">{c.title}</div>
                        <div className="mt-2 font-serif text-2xl">{c.body}</div>
                    </div>
                ))}
            </section>

            <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
                <div className="bg-brand-navy text-white rounded-3xl p-8 md:p-12 text-center">
                    <h2 className="font-serif text-4xl">Get Notified</h2>
                    <p className="mt-2 text-stone-300">Be the first to register when the 5K opens.</p>
                    {done ? (
                        <div className="mt-6 text-brand-lime-light text-lg" data-testid="5k-notify-success">You&apos;re on the list. Thank you!</div>
                    ) : (
                        <form onSubmit={submit} className="mt-6 grid sm:grid-cols-[1fr_1fr_auto] gap-3" data-testid="5k-notify-form">
                            <input
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Your name"
                                data-testid="5k-input-name"
                                className="bg-brand-cream/10 border border-white/20 rounded-full px-5 py-3 placeholder:text-stone-400 focus:outline-none focus:border-brand-lime-light"
                            />
                            <input
                                required
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email"
                                data-testid="5k-input-email"
                                className="bg-brand-cream/10 border border-white/20 rounded-full px-5 py-3 placeholder:text-stone-400 focus:outline-none focus:border-brand-lime-light"
                            />
                            <button
                                disabled={loading}
                                data-testid="5k-notify-submit"
                                className="px-6 py-3 rounded-full bg-brand-lime text-white font-semibold disabled:opacity-50"
                            >
                                {loading ? "..." : "Notify Me"}
                            </button>
                        </form>
                    )}
                    {error && <div className="mt-3 text-sm text-rose-300">{error}</div>}
                </div>
            </section>
        </PageLayout>
    );
}
